module.exports = __webpack_public_path__ + "media/images/partners/barefoot_square-76f617930f3cb0ef7462d282894af253.svg";